import { PropsWithChildren } from "react";
import { Flex } from "@radix-ui/themes";

export function InteractionViewContent({ children }: PropsWithChildren) {
  return (
    <Flex
      height={"100%"}
      pt={"12px"}
      pl={"24px"}
      direction={"column"}
      overflow={"hidden"}
    >
      {children}
    </Flex>
  );
}
